<div class="center">
  <div class="slider" data-pos="0">
    <div class="slider__slides">
      <img src="assets/img/carousel/slide-1.png" class="slider__slide" />
      <img src="assets/img/carousel/slide-2.png" class="slider__slide" />
      <img src="assets/img/carousel/slide-3.png" class="slider__slide" />
    </div>
    <div class="slider__dots">
      <a href="#" class="slider__indicator"></a>
      <a href="#" class="slider__dot" data-pos="0"></a>
      <a href="#" class="slider__dot" data-pos="1"></a>
      <a href="#" class="slider__dot" data-pos="2"></a>
    </div>
  </div>
</div>
